<template>
  <v-container grid-list-md>
    <v-toolbar style="margin-bottom:1em">
      <v-toolbar-title>Technology Services Dashboard</v-toolbar-title>
    </v-toolbar>
    <v-row>
      <v-col :cols="12" md="6" lg="4">
        <v-card>
          <!-- <v-card-text style="padding-bottom:0">
            <v-text-field v-model="filter" label="Filter Links" hint="Note: Filter searches both labels and links" persistent-hint outlined></v-text-field>
          </v-card-text>
          <v-list v-for="({ text, links }, index) in filteredLinks" :key="'list-' + index">
            <v-subheader :style="dark ? 'background-color:#333' : 'background-color:#eee'">{{ text }}</v-subheader>
            <v-list-item v-for="({ text, link, internal }, linkIndex) in links" :key="'link-' + index + '-' + linkIndex" :to="internal ? link : null" :href="internal ? null : link" :target="internal ? '' : '_blank'">
              <v-list-item-title>{{ text }}</v-list-item-title>
            </v-list-item>
          </v-list> -->
          <link-list category="Tech Services" />
        </v-card>
      </v-col>
      <v-col :cols="12" md="6" lg="4">
        <v-card>
          <v-toolbar>
            <v-toolbar-title>Department Employees</v-toolbar-title>
          </v-toolbar>
          <v-list>
            <v-list-item v-for="({ name, ext, office, cell }, index) in employees" :key="'emp-' + index">
              <v-list-item-content>
                <v-list-item-title>{{ name }}</v-list-item-title>
                <v-list-item-subtitle>{{ office }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-list-item-subtitle>Extension: {{ ext }}</v-list-item-subtitle>
                <v-list-item-subtitle v-if="cell">Cell: {{ cell }}</v-list-item-subtitle>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col :cols="12" lg="4">
        <v-card>
          <v-toolbar>
            <v-toolbar-title>GreatScots Search</v-toolbar-title>
          </v-toolbar>
          <home-directory-search></home-directory-search>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { computed, ref } from '@vue/composition-api'
export default {
  components: {
    HomeDirectorySearch: () => import('@/components/tech/homeDirectorySearch'),
    LinkList: () => import('@/components/system/LinkList')
  },
  setup (props, { root }) {
    const user = computed(() => root.$store.state.user.spoof || root.$store.state.user)
    const dark = computed(() => 'settings' in user.value && 'darkMode' in user.value.settings ? user.value.settings.darkMode : false)
    const roles = computed(() => root.$store.state.roles)

    const tab = ref(0)
    const employees = ref([
      { name: 'Alexander, Braden', ext: '1215', office: 'MH110' },
      { name: 'Crocker, Marjorie', ext: '1544', office: 'MH122', cell: '423-208-2627' },
      { name: 'Endlich, Matthew', ext: '1541', office: 'MH110' },
      { name: 'Leauby, Brandan', ext: '1540', office: 'MH110' },
      { name: 'Locke, Randy', ext: '1546', office: 'MH123' },
      { name: 'Lynch, Paula', ext: '1543', office: 'MH120' },
      { name: 'Mitchell, Ben', ext: '1538', office: 'MH123' },
      { name: 'Moon, Jon', ext: '1556', office: 'MH120' },
      { name: 'Ray, Ben', ext: '1658', office: 'MH110' },
      { name: 'Wright, Matt', ext: '1557', office: 'MH110' },
      { name: 'AV Helpdesk', ext: '1220', office: 'MH110' },
      { name: 'Helpdesk', ext: '1219', office: 'MH110' }
    ])

    return {
      user,
      dark,
      roles,
      employees,
      tab
    }
  }
}
</script>
